import React from 'react';
import BG from './bg.png';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Header from './header';
import Content from './content';
import Footer from './footer';
import ModalRegistrationNew from './modalRegistrationNew';
import Slot from './slot';
import { useRouter } from '../hook/useRouter';
import { setGetSettingsCodeCountry } from '../store/settings/thunk/setGetSettingsCodeCountry';
import { setGetSettingsCountry } from '../store/settings/thunk/setGetSettingsCountry';
import { setGetSettingsCurrency } from '../store/settings/thunk/setGetSettingsCurrency';
import { useDispatch } from 'react-redux';

const useStyles = makeStyles(() => ({
    root: {
        width: '100vw', 
        height: '100%', 
        overflow: 'hidden', 
        display: 'flex', 
        flexDirection: 'column', 
        backgroundImage: `url(${BG})`, 
        backgroundSize: 'cover'
    }
}))

const Mobile = ({isShowModal, handleSetIsShowModal}) => {
    const [deferredPrompt, setDeferredPrompt] = React.useState(null);

    React.useEffect(() => {
        const handleBeforeInstallPrompt = (e) => {
        e.preventDefault();
        setDeferredPrompt(e);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        return () => {
        window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    const handleAddToHomeScreen = () => {
        if (deferredPrompt) {
        deferredPrompt.prompt();
        deferredPrompt.userChoice.then((choiceResult) => {
            setDeferredPrompt(null);
        });
        }
    }
 
    const classes = useStyles();
    const dispatch = useDispatch();

    const router = useRouter();
    const referral = router?.query?.referral;

    if (referral) {
        localStorage.removeItem('referral');
        localStorage.setItem('referral', referral);
    }

    React.useEffect(() => {
        dispatch(setGetSettingsCodeCountry());
        dispatch(setGetSettingsCountry());
        dispatch(setGetSettingsCurrency());
    }, [])

    return (
        <div className={classes.root}>
            {/* <Header /> */}
            <Content handleSetIsShowModal={handleSetIsShowModal} isShowModal={isShowModal} handleAddToHomeScreen={handleAddToHomeScreen} />
            {
                isShowModal && (
                    <ModalRegistrationNew isShowModal={isShowModal} handleSetIsShowModal={handleSetIsShowModal}/>
                )
            }
            
        </div>
    )
}

export default Mobile;